import { RouteRecordRaw } from 'vue-router'

export const handoffRoutes: RouteRecordRaw[] = [
  {
    path: '/handoff',
    name: 'handOff',
    component: () =>
      import(
        /* webpackChunkName: "handoff" */
        '@/views/HandOff.vue'
      ),
    meta: {
      title: 'Passagem de plantão',
      onlyLoggedIn: true
    }
  }
]
